import { Component } from '@angular/core';
import { ApplicationState } from '../../../store/reducers/index';
import { Store } from '@ngrx/store';
import * as AliasActions from '../../store/actions/alias.actions';

@Component({
  selector: 'mprd-confirm-delete-alias',
  templateUrl: 'confirm-delete-alias.component.html',
})
export class ConfirmDeleteAliasComponent {
  aliasId: string;
  destroy: () => void;

  constructor(private store: Store<ApplicationState>) {}

  onConfirm() {
    this.store.dispatch(new AliasActions.RemoveAction(this.aliasId));
    this.destroy();
  }

  onCancel() {
    this.destroy();
  }
}
